module.exports = __webpack_public_path__ + "img/antes_despues_137.f094eddf.png";